module.exports = __webpack_public_path__ + "img/ash.b5e1bf69.jpg";